import { OrganizationDetail } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrganizationDetail>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

// Request/failure are keyed by the requested slug (action.payload.id), consistent with the
// shared factory handlers. Success is handled separately: the shared `handleGetOneSuccess` keys
// `byId`/`isFetching`/`isFetched` by the entity's real numeric id, but the by-slug selector reads
// `byId` by the requested slug, so this custom handler keys success state by
// `action.payload.params.slug` (set by the saga) instead, while leaving the entity's own `id`
// field untouched (downstream code still needs the real numeric org id).
const getOrganizationBySlugReducer = createReducer<State, Actions>(initialState, {
  [actions.getOrganizationBySlug.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getOrganizationBySlug.success.type]: (draft, action: any) => {
    const slug = action.payload.params?.slug;
    if (!slug) return;
    delete draft.isFetching[slug];
    draft.byId[slug] = action.payload.entity;
    draft.isFetched[slug] = true;
  },
  [actions.getOrganizationBySlug.failure.type]: actionsHandlers.handleGetOneFailure,
});

export default getOrganizationBySlugReducer;
